var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box"},[_c('div',{staticClass:"page-title-right"},[_c('b-breadcrumb',{staticClass:"m-0",attrs:{"items":_vm.locale_items}})],1),_c('h4',{staticClass:"page-title"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.locale_title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }